import { useQuery } from '@apollo/client';
import { QueryResult } from '@/shared/types/generated';
import { GET_USER } from '@/shared/queries';
import { useAuth } from '@/services/auth/AuthProvider';
import useStore from '@/stores/useStore';
import { NetworkStatus } from '@apollo/client';
import SentryService from '@/services/sentry/Sentry.service';
import useInstantStylingStore from '@/stores/useInstantStylingStore';

export const useGetUser = () => {
  const { isAuthenticated } = useAuth();
  const setIsStylist = useStore((state) => state.setIsStylist);
  const setIsInstantStylingActive = useInstantStylingStore(
    (state) => state.setIsInstantStylingActive,
  );

  const { data, loading, refetch, networkStatus } = useQuery<
    QueryResult<'user'>
  >(GET_USER, {
    skip: !isAuthenticated,
    notifyOnNetworkStatusChange: true,
    onError: (error) => {
      SentryService.captureError('Error in get user query', error);
    },
    onCompleted: (data) => {
      setIsStylist(Boolean(data?.user?.type === 'STYLIST'));

      if (data?.user?.stylist?.instantStyling?.isActive !== undefined) {
        setIsInstantStylingActive(data.user.stylist.instantStyling.isActive);
      }
    },
  });

  const isLoadingUser = loading && networkStatus !== NetworkStatus.refetch;
  const user = data?.user || null;

  return { isLoadingUser, user, refetch };
};
